/**
 * Enumeration of all react-query keys availbale in our app.
 */
export const mutationKeys = {
  addNewTeam: 'add-new-team-mutation',
  addTeamMembers: 'add-team-members',
  updateMemberRole: 'update-member-role',
  removeMember: 'remove-member',
  org: {
    updateAcl: 'update-acl',
  },
  builder: {
    deleteCustomDomain: 'delete-custom-domain',
    updateMakyoDomain: 'update-makyo-domain',
    updateSettings: 'update-setting',
    updateAppIcon: 'update-app-icon',
  },
  login: {
    deleteAccount: 'delete-account',
    restoreAccount: 'restore-account',
  },
  user: {
    addTeam: 'add-team',
    updateReferral: 'update-referral',
    deleteProfile: 'delete-profile',
    updateUserAcl: 'update-user-acl',
    updateProfile: 'update-profile',
    readNotification: 'read-notification',
    unreadNotification: 'unread-notification',
    deleteNotification: 'delete-notification',
  },
  // ...add more stuff here
} as const
